export default "__VITE_PUBLIC_ASSET__7aa3c9f2__"